/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBackground = createReactComponent("background", "IconBackground", [
  ["path", { d: "M4 8l4 -4", key: "svg-0" }],
  ["path", { d: "M14 4l-10 10", key: "svg-1" }],
  ["path", { d: "M4 20l16 -16", key: "svg-2" }],
  ["path", { d: "M20 10l-10 10", key: "svg-3" }],
  ["path", { d: "M20 16l-4 4", key: "svg-4" }]
]);

export { IconBackground as default };
//# sourceMappingURL=IconBackground.js.map
